import type { JSX } from 'react';

/** @graph-connects none */
export type ViewMode = 'current' | 'history';

/**
 * @graph-stack styling-pattern-watch
 * @graph-domain Styling
 * @graph-business 現在スナップショット / 時系列履歴 の切替ボタン
 * @graph-connects none
 */
export function ViewSwitcher(props: {
  view: ViewMode;
  onChange: (v: ViewMode) => void;
}): JSX.Element {
  return (
    <div className="view-switcher" role="tablist">
      <button
        type="button"
        className={`vs-btn ${props.view === 'current' ? 'active' : ''}`}
        onClick={() => {
          props.onChange('current');
        }}
      >
        <svg
          width={13}
          height={13}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.6}
        >
          <circle cx={8} cy={8} r={6} />
          <path d="M8 4v4l2.5 2.5" />
        </svg>
        現在のスナップショット
      </button>
      <button
        type="button"
        className={`vs-btn ${props.view === 'history' ? 'active' : ''}`}
        onClick={() => {
          props.onChange('history');
        }}
      >
        <svg
          width={13}
          height={13}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.6}
        >
          <path d="M2 12l3-4 3 2 5-6" />
          <path d="M2 14h12" />
        </svg>
        時系列履歴
      </button>
    </div>
  );
}
